import Constant from '@/common/constant/Constant';

/**
 * Get user in coporation by email
 * @param {*} corporationId 
 * @param {*} email 
 * @returns expressionStr
 */
export const getExpressionUserInCorporationByEmail = (corporationId, email) => {
    let expression = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#mail = :mail_eq',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#mail': 'mail'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ":mail_eq": {
                S: email
            }
        },
        Limit: Constant.DEFAULT_LIMIT
    };
    return JSON.stringify(expression);
};

/**
 * Get user general and internal in coporation by email
 * @param {*} corporationId 
 * @param {*} email 
 * @returns expressionStr
 */
 export const getExpressionUserGeneralAndInternalInCorporationByEmail = (corporationId, email) => {
    let expression = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#mail = :mail_eq AND (#type = :general OR #type = :internal)',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#mail': 'mail',
            '#type':'type'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ":mail_eq": {
                S: email
            },
            ":general": {
                S: Constant.USER_TYPE.GENERAL
            },
            ":internal": {
                S: Constant.USER_TYPE.INTERNAL
            }
        },
        Limit: Constant.DEFAULT_LIMIT
    };
    return JSON.stringify(expression);
};


/**
 * prepareParamsGetAllUserInCorporation
 * get all user in corp
 * @param {*} corporationId 
 * @returns 
 */
export const prepareParamsGetAllUserInCorporation = (corporationId) => {
    let expression = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#active <> :active_notEq',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#active': 'active',
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':active_notEq' : {
                "N": `${Constant.ACTIVE_FLAG.DELETED}`
            }
        },
        Limit: Constant.DEFAULT_LIMIT
    };
    
    return expression;
}

/**
 * prepareParamsGetAllUserInCorporation
 * get all user in corp
 * @param {*} corporationId 
 * @returns 
 */
 export const prepareParamsGetAllUserInBaseUser = (corporationId) => {
    let expression = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#active = :active_eq AND (#type = :general OR #type = :internal)',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#active': 'active',
            '#type':'type'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':active_eq' : {
                "N": `${Constant.ACTIVE_FLAG.ACTIVE}`
            },
            ":general": {
                S: Constant.USER_TYPE.GENERAL
            },
            ":internal": {
                S: Constant.USER_TYPE.INTERNAL
            },
        },
        Limit: Constant.DEFAULT_LIMIT
    };
    
    return expression;
}

/**
 * prepareParamsGetAllUserInCorporation
 * get all user in corp
 * @param {*} corporationId 
 * @returns 
 */
export const prepareParamsGetAllUserActiveInCorporation = (corporationId) => {
    return {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#active': 'active',
        },
        FilterExpression: '#active = :active_eq',
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':active_eq' : {
                "N": `${Constant.ACTIVE_FLAG.ACTIVE}`
            }
        },
        Limit: Constant.DEFAULT_LIMIT
    };
}


/**
 * prepareParamsGetAllCustomerWithoutDeletedInCorporation
 * get all customer in corp
 * @param {*} corporationId 
 * @returns 
 */
 export const prepareParamsGetAllCustomerWithoutDeletedInCorporation = (corporationId) => {
    let expression = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#type = :type AND #active <> :active_notEq',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#type': 'type',
            '#active': 'active'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ":type": {
                S: Constant.USER_TYPE.CUSTOMER
            },
            ":active_notEq": {
                "N": `${Constant.ACTIVE_FLAG.DELETED}`
            }
        },
        Limit: Constant.DEFAULT_LIMIT
    };
    
    return expression;
}


/**
 * prepareParamsGetAllUserWithoutTypeInCorporation
 * @param {*} corporationId 
 * @param {*} typeOfWithout 
 * @returns 
 */
export const prepareParamsGetAllUserWithoutTypeInCorporation = (corporationId, typeOfWithout) => {
    if (!typeOfWithout){
        typeOfWithout = ""
    }
    let expression = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        FilterExpression: '#typeOfWithout <> :typeOfWithout',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            '#typeOfWithout': 'type'
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ":typeOfWithout": {
                S: typeOfWithout
            }
        },
        Limit: Constant.DEFAULT_LIMIT
    };
    
    return expression;
}


/**
 * preparePramsGetAllAdminOfCorporation
 * @param {*} corporationId 
 * @returns 
 */
export const preparePramsGetAllAdminOfCorporation = (corporationId) => {
    let params = {
        IndexName: Constant.GSI.CORPORATION_ID_INDEX,
        KeyConditionExpression: '#affiliationOrganization = :affiliationOrganization',
        ExpressionAttributeNames: {
            '#affiliationOrganization': 'affiliationOrganization',
            "#privilege": "privilege"
        },
        ExpressionAttributeValues: {
            ':affiliationOrganization': {
                S: corporationId
            },
            ':privilege_admin': {
                S: Constant.PRIVILEGE_USER.ADMIN
            },
            ':privilege_admin_owner': {
                S: Constant.PRIVILEGE_USER.ADMIN_OWNER
            }
        },
        FilterExpression: '#privilege = :privilege_admin OR #privilege = :privilege_admin_owner ',
        Limit: Constant.DEFAULT_LIMIT
    };

    return params;
} 